import React from 'react';
import { styled } from '@mui/material';

import { useViewport } from 'contexts/viewport';
import { Avatar, Divider, Icon, Stack, Text } from 'shell/components';
import { getUserCountry, getUserPreferredFullName, getUserPronoun } from 'utils/helper';

const MemberCard = ({ accountUser }) => {
    const { device } = useViewport();

    return (
        <CustomStack device={device} divider={<Divider />} spacing={4}>
            <Stack direction={'row'} spacing={2}>
                <Avatar size={'medium'} user={accountUser} />
                <Stack justifyContent={'center'}>
                    <Text variant={'p1'}>{getUserPreferredFullName(accountUser)}</Text>
                    {accountUser.pronoun && <Text variant={'p1'}>({getUserPronoun(accountUser.pronoun)})</Text>}
                </Stack>
            </Stack>
            <Stack spacing={2}>
                <Stack alignItems={'center'} direction={'row'} spacing={2}>
                    <CustomIcon kind={'email'} />
                    <Text variant={'p2'}>{accountUser.email}</Text>
                </Stack>
                <Stack alignItems={'center'} direction={'row'} spacing={2}>
                    <CustomIcon kind={'locationEmpty'} />
                    <Text variant={'p2'}>{accountUser.country ? getUserCountry(accountUser.country) : '-'}</Text>
                </Stack>
                <Stack alignItems={'center'} direction={'row'} spacing={2}>
                    <CustomIcon kind={'clock'} />
                    <Text variant={'p2'}>{accountUser.timezone ? accountUser.timezone : '-'}</Text>
                </Stack>
            </Stack>
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ device, theme }) => {
    return {
        borderRadius: '12px',
        padding: theme.spacing(4),
        width: device === 'mobile' ? '100%' : theme.spacing(80),
        boxShadow: theme.palette.ensightful.shadows[1],
    };
});

const CustomIcon = styled(Icon)(({ theme }) => {
    return {
        fontSize: `${theme.typography.p2.fontSize.large}rem`,
        color: theme.palette.ensightful.neutral[900],
    };
});

export default MemberCard;
